import bindableDeleteTour from '@monofe/ui-workspace/delete-tour/bind';
import bindableDownloadLanguage from '@monofe/ui-workspace/download-language/bind';
import bindableDownloadTour from '@monofe/ui-workspace/download-tour/bind';
import bindables from './bindables';
import { injectTourDataResolver } from './tourDataResolver.if';

function _overrides() {
  const dep = Object.freeze({
    get resolver() {
      return injectTourDataResolver();
    }

  });
  bindableDownloadLanguage.setBuildDependencies(dep);
  bindableDownloadTour.setBuildDependencies(dep);
  bindableDeleteTour.setBuildDependencies(dep);
}

async function _nodeBind(container) {
  const binders = await bindables.all();
  binders.forEach(binder => {
    container.addBindable(binder);
  });
  await container.resolveAll();
}

async function _windowBind(container) {
  const binders = await bindables.all();
  binders.forEach(binder => {
    container.addBindable(binder);
  });
  await container.resolveAll();
}

function bind(binder, env) {
  _overrides();

  const isWindowDefined = typeof window !== 'undefined';
  const isClientSide = env ? env === 'Client' : isWindowDefined;
  return isClientSide ? _windowBind(binder) : _nodeBind(binder);
}

export default bind;